import BlockInstagram from './block-instagram';

export default BlockInstagram;